export default __webpack_public_path__ + "static/media/img-sward.f6da5f36.gif";